import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ElementRef, Input, OnChanges,
  OnDestroy,
  OnInit, SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CarsService} from '../../cars/cars.service';
import {faHeart as fasFaHeart, faInfoCircle, faShoppingCart} from '@fortawesome/free-solid-svg-icons';
import {faHeart as farFaHeart} from '@fortawesome/free-regular-svg-icons';
// import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {CarDialogOverviewComponent} from '../../cars/car-dialog-overview/car-dialog-overview.component';
import {CarModalComponent} from '../../cars/car-modal/car-modal.component';
import {NbDialogConfig, NbDialogService} from '@nebular/theme';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {CalculatorCarsComponent} from '../../calculator/calculator-cars.component';
import {BehaviorSubject, forkJoin, Observable} from 'rxjs';
import {CalculatorService} from '../../calculator/calculator.service';
// import {FilterMeta} from '../filter-meta';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {TemplatePortal} from '@angular/cdk/portal';
import {AuthenticateService} from '../../auth/authenticate.service';
import {ChangeContext, LabelType, Options} from '@angular-slider/ngx-slider';
import {CurrencyPipe} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../../services/language.service';
import {CurrencyService} from '../../services/currency.service';
import {LocaleService} from '../../services/locale.service';
import {map, switchMap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {selectLoginState} from '../../auth/login/selectors/login.selectors';
import {AppState} from '../../reducers';
import {State} from '../../auth/login/reducers/login.reducer';

// import {ComponentPortal, TemplatePortal} from '@angular/cdk/portal';

export interface Model {
  name: string;
  fuelType: string;
  fuelType_h: string;
}

export interface FilterMeta {
  year: number;
  make: string;
  make_h: string;
  model: Model[];
}

export interface DialogData {
  car: any;
}

declare let dataLayer: Array<any>;

@Component({
  selector: 'app-cars-grid-coll-pub',
  templateUrl: './cars-grid-coll-pub.component.html',
  styleUrls: ['./cars-grid-coll-pub.component.scss']
})
export class CarsGridCollPubComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @ViewChild('carContainer') carContainer: ElementRef;
  @ViewChild('loadingOverlay') loadingOverlay: TemplateRef<any>;

  currencyPipe = new CurrencyPipe('he-il');


  overlayRef: OverlayRef;

  loading = false;
  hasMore = true;

  page = 1;
  carId = 0;


  // price range
  sliderValue = 0;
  sliderHighValue = 5000000;
  sliderOptions: Options = {
    floor: 0,
    ceil: 5000000,
    step: 400000,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  // year range
  sliderYearValue = 0;
  sliderHighYearValue = 1990;
  sliderYearOptions: Options = {
    floor: 1970,
    ceil: 1990,
    step: 1,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  // km range
  sliderKmValue = 0;
  sliderKmHighValue = 1000000;
  sliderKmOptions: Options = {
    floor: 0,
    ceil: 1000000,
    step: 10000,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  locatedInIsrael: 'All' | 'Yes' | 'No' = 'All';
  saleCondition: 'All' | 'New' | 'Used' = 'All';
  importType: 'Commercial' | 'Taxi' = 'Commercial';
  year = -1;
  make = '';
  model = '';
  fueltype = '';
  priceRange = '0-5000000';
  kmRange = '0-1000000';


  constructor(
    private activatedRoute: ActivatedRoute,
    private carsService: CarsService,
    private calculatorService: CalculatorService,
    public dialogService: NbDialogService,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private componentFactoryResolver: ComponentFactoryResolver,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private authService: AuthenticateService,
    private router: Router,
    private el: ElementRef,
    private store: Store<AppState>,
    private translate: TranslateService,
    private languageService: LanguageService,
    public currencyService: CurrencyService,
    public localeService: LocaleService,
    // private componentPortal: ComponentPortal<LoadingSpinnerComponent>
  ) {
    // Specify LoadingSpinnerComponent
    // const loadingPortal = new ComponentPortal<LoadingSpinnerComponent>(LoadingSpinnerComponent);
  }

  private isEnglish(): boolean {
    return this.languageService.getCurrentLanguage() === 'en';
  }

  // Display-only translation; bound [value] stays the Hebrew string so
  // filter/search logic is unchanged.
  displayMake(makeH: string): string {
    if (makeH === 'הכל') { return this.translate.instant('COMMON.ALL'); }
    if (!this.isEnglish()) { return makeH; }
    const m: any = (this.filterMetaMakes as any[]).find((x: any) => x.make_h === makeH);
    return m && m.make ? m.make : makeH;
  }

  displayFuelType(label: string): string {
    if (label === 'הכל') { return this.translate.instant('COMMON.ALL'); }
    if (!this.isEnglish()) { return label; }
    const f: any = (this.filterMetaFuelTypes as any[]).find((x: any) => x && x.label === label);
    return f && f.name ? f.name.charAt(0).toUpperCase() + f.name.slice(1) : label;
  }

  displayYear(year: any): string {
    if (year === 'הכל') { return this.translate.instant('COMMON.ALL'); }
    return year;
  }

  @ViewChild('host', {read: ViewContainerRef}) host: ViewContainerRef;
  // calcRef: ComponentRef<CalculatorCarsComponent>;
  isLoading = new BehaviorSubject<boolean>(false);
  vehicleValue = new BehaviorSubject<any>(null);

  fasFaHeart = fasFaHeart;
  farFaHeart = farFaHeart;
  // faCartPlus = faCartPlus;
  faShoppingCart = faShoppingCart;
  // fasFaInfo = faInfoCircle;
  fasFaInfo = faInfoCircle;
  faTimes = faTimes;



  cars = [];
  fetchedCars = [];
  currencies: any;
  carById: any; // fetched by link id, since we work by random and filter

  filterMetaCars: FilterMeta[] = [];
  filterMetaYears: any[] = [];
  filterMetaMakes = [];
  filterMetaFuelTypes = [];
  filterMetaModels = [];

  // protected readonly faMapMarkerAlt = faMapMarkerAlt;

  years = ['הכל'];
  makes = ['הכל'];
  models = ['הכל'];
  fuelTypes = ['הכל'];

  selectedYear = 'הכל';
  selectedMake = 'הכל';
  selectedModel = 'הכל';
  selectedFuelType = 'הכל';

  isFilterCollapsed = false;

  showDirham = false;
  carModalDialogLoaded = false;

  user$: Observable<State>;
  user: any;

  ngOnInit() {
    this.locatedInIsrael = this.localeService.israeliMarket ? 'All' : 'No';
    this.currencyService.ensureLoaded();
    console.log('ngOnInit - coll');
    // this.store.select(selectLoginState).pipe(map(lState => {
    //   if (lState.isLogin) {
    //     this.user = lState.userData;
    //     console.log(this.user);
    //   }
    //   // return lState;
    // })).subscribe();

    this.showDirham = sessionStorage.getItem('user-id') === '530';

    this.isFilterCollapsed = this.isMobileView();
    // window.addEventListener('scroll', this.onWindowScroll, true);
    // this.initialize();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.selected && changes.selected.currentValue === true) {
    //   window.addEventListener('scroll', this.onWindowScroll, true);
    //   this.updateOnTabSelection();
    // } else {
    //   window.removeEventListener('scroll', this.onWindowScroll, true);
    // }
  }

  private updateOnTabSelection() {

  }

  ngOnDestroy() {
    // window.removeEventListener('scroll', this.onWindowScroll, true);
  }

  castUSDToDirham(usd: number): number {
    const conversionRate = 3.67; // Example conversion rate, please use the current rate
    return usd * conversionRate;
  }

  // Method to convert EUR to Dirham
  castEURToDirham(eur: number): number {
    const conversionRate = 4.05; // Example conversion rate, please use the current rate
    return eur * conversionRate;
  }

  getCarPrice(car: any) {
    if (this.showDirham){
      return (this.castUSDToDirham(car.CarPrice) + this.castEURToDirham(2000)) * 1.05 + this.castUSDToDirham(1500);
    }
    return car.C_Price_Collector;
  }


  target;

  isAndroid(): boolean {
    // Check if the user agent is Android
    return /android/i.test(navigator.userAgent);
  }

  resetScrollToTop(): void {
    // setTimeout(() => {
    // if (document.documentElement.scrollTop || document.body.scrollTop) {
    //   window.scroll(0, 0);  // For older browsers
    // } else {
    //   window.scrollTo({ top: 0, behavior: 'auto' }); // For modern browsers
    // }}, 100);

    // setTimeout(() => {
    if (this.target) {
      this.target.scrollTo({top: 0, behavior: 'smooth'});
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
    // }}, 200);

  }

  resetScroll = () => {
    if (this.isAndroid()) {
      // this.target?.removeEventListener('scroll', this.onWindowScroll, true);
      this.resetScrollToTop();
      // this.target?.addEventListener('scroll', this.onWindowScroll, true);
    } else {
      // this.target?.removeEventListener('scroll', this.onWindowScroll, true);
      this.target?.scrollTo({top: 0, behavior: 'smooth'});
      // this.target?.addEventListener('scroll', this.onWindowScroll, true);
    }
  }

  onWindowScroll = (event: any): void => {

    if (this.carModalDialogLoaded ) {
      return;
    }
    // console.log(event);
    // const element = document.getElementById('cardContainer');
    const element = event.target;
    if (this.isAndroid()) {
      this.target = event.target;
    } else {
      this.target = element;
    }
    if (element) {
      const pos = element.scrollTop + element.offsetHeight;
      const max = element.scrollHeight;

      if (pos >= max) {
        console.log('load ---------');
        // Your logic to load more items or whatever you want to do when reaching the bottom


        const params = {
          page: this.page + 1,
          yearMin: this.sliderYearValue,
          yearMax: this.sliderHighYearValue,
          make: this.make,
          model: this.model,
          fueltype: this.fueltype,
          priceRange: this.priceRange,
          kmRange: this.kmRange,
          locatedInIsrael: this.locatedInIsrael,
          saleCondition: this.saleCondition,
          importType: this.importType,
        };

        // console.log(pos, max);


        this.loadMoreItems(params);

      }
    }
  };

  handleLoadMore = (): void => {
    if (this.carModalDialogLoaded) {
      return;
    }


    console.log('load ---------');
    // Your logic to load more items or whatever you want to do when reaching the bottom


    const params = {
      page: this.page + 1,
      yearMin: this.sliderYearValue,
      yearMax: this.sliderHighYearValue,
      make: this.make,
      model: this.model,
      fueltype: this.fueltype,
      priceRange: this.priceRange,
      kmRange: this.kmRange,
      locatedInIsrael: this.locatedInIsrael,
      saleCondition: this.saleCondition,
      importType: this.importType,
    };


    this.loadMoreItems(params);

  }

  async initialize() {
    // await this.checkUserAuthentication();
    this.createOverlay();
    console.log('initialize');
    this.loadData();
  }

  async checkUserAuthentication() {
    const userId = sessionStorage.getItem('user-id');
    // if (!userId) {
    //   this.authService.checkAuth().subscribe((res: any) => {
    //     if (res.code === 200) {
    //       sessionStorage.setItem('user-id', res.data.id);
    //       // Your dataLayer logic
    //     }
    //   });
    // }
  }

  createOverlay() {
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([
          {
            originX: 'center',
            originY: 'center',
            overlayX: 'center',
            overlayY: 'center',
          },
        ]),
    });

    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);
    this.overlayRef.attach(loadingPortal);
  }

  loadData() {
    try {
      forkJoin([
        this.carsService.filterPagedColl({
          page: 1,
          yearMin: this.sliderYearValue,
          yearMax: this.sliderHighYearValue,
          make: this.make,
          model: this.model,
          fueltype: this.fueltype,
          priceRange: this.priceRange,
          kmRange: this.kmRange,
          locatedInIsrael: this.locatedInIsrael,
          saleCondition: this.saleCondition,
          importType: this.importType,
        }),
        // this.calculatorService.getCurrencies(),
        this.carsService.getFilterMetaColl(),
      ])?.subscribe(([cars, filterMeta]: [any, any]) => {
        this.cars = cars.map((car) => ({
          ...car,
          isLiked: car.interest === 'Liked'
        }));
        this.fetchedCars = this.cars;

        if (this.cars.length === 0) {
          this.overlayRef.detach();
          this.hasMore = false;
          return;
        }

        if (this.filterMetaCars) {
          // this.currencies = currencies.data;
          console.log(filterMeta);
          this.filterMetaCars = filterMeta.cars;

          this.filterMetaModels = !this.filterMetaCars ? [] : [].concat(...this.filterMetaCars.map(vehicle => vehicle.model));

          this.filterMetaFuelTypes = ['הכל'].concat(filterMeta.fueltypes);
          this.fuelTypes = ['הכל'].concat(filterMeta.fueltypes.map((fuelType) => fuelType.label));
          this.filterMetaYears = ['הכל'].concat(filterMeta.years);


          this.filterMetaMakes = filterMeta.manufacturers;
          this.makes = ['הכל'].concat(filterMeta.manufacturers.map((manufacturer) => manufacturer.make_h));
          // console.log(this.cars);
          // console.log(new Date().getTime());

          this.overlayRef.detach();

          this.load();

          this.hasMore = cars.length !== 0;
        } else {
          this.overlayRef.detach();
          this.hasMore = false;
        }
      });
    } catch (error) {
      console.error(error);
      this.overlayRef.detach();
    }
  }

  load() {
    let carById = this.cars.find((car) => car.id === this.carById);
    if (!carById) {
      this.carsService.getCarByIdNew(this.carId).subscribe(cars => {
        carById = cars[0];
        if (carById) {
          this.toggleMoreInfo(carById);
        }
      },
        (error) => {
          console.error(`An error occurred: ${error}`);
        }
      )
    } else {
      this.toggleMoreInfo(carById);
    }
  }

    loadMoreItems(params: any) {
      if (!this.selected) {
        return;
      }

      console.log('loadMoreItems');
      this.carsService.filterPagedColl(params).subscribe(cars => {
        this.cars = [...this.cars, ...cars.map((car) => ({
          ...car,
          isLiked: car.interest === 'Liked'
        }))
        ];
        this.fetchedCars = this.cars;
        this.page++;

        console.log('page', this.page);
        console.log(this.cars);
        this.hasMore = cars.length !== 0;
      });
    }

    ngAfterViewInit() {
      this.initialize();
      this.isLoading.next(true);
      const factory = this.componentFactoryResolver.resolveComponentFactory(CalculatorCarsComponent);
      // this.calcRef = this.host.createComponent(factory);

      // this.calcRef.instance.calcInitialized.subscribe(() => {
      //   console.log('initialized');
      //   this.isLoading.next(false);
      //
      //   // this.initialize();
      // });
      this.isLoading.next(false);
      // this.calcRef.instance.initialize();

    }

    openDialog(car: any): void {
      this.dialog.open(CarDialogOverviewComponent, {
        width: '80vw',
        data: {car}
      });
    }

    toggleLike(car) {
      car.isLiked = !car.isLiked;
      const interest = car.isLiked ? 'Liked' : 'Disliked';
      this.carsService.updateInterest(car.id, interest, this.importType).subscribe((res: any) => {
        console.log('bb', res);
      });
    }

    toggleInterest(car) {
      this.carsService.updateInterest(car.id, 'Interested', this.importType).subscribe((res: any) => {
        console.log('aa', res);
      });
    }

    isMobileView(): boolean {
      return this.breakpointObserver.isMatched(Breakpoints.Handset);
    }

  handleClick(car: any) {
      this.carById = car?.id;
      this.load();
    }

    toggleMoreInfo(car: any) {

      // await this.router.navigate([], {
      //   queryParams: {
      //     id: car.id,
      //     importType: this.importType
      //   },
      //
      //   queryParamsHandling: 'merge'
      // });

      dataLayer.push({
        event: 'button_click_more_info_list_pub',
        item_id: car.id,
        item_name: car.Manufacturer + ' ' + car.Model,
        item_price: car.CarPrice,
        item_year: car.ManufactureDate,
        user_id: sessionStorage.getItem('user-id') ?? -1,
        userId: sessionStorage.getItem('user-id') ?? -1,
      });

      const isMobile = this.isMobileView();

      const dialogConfig: NbDialogConfig<any> = {
        hasBackdrop: true,
        closeOnEsc: true,
        backdropClass: '',
        dialogClass: isMobile ? 'full-screen-dialog' : '',
        closeOnBackdropClick: false,
        hasScroll: false,
        autoFocus: false,
        viewContainerRef: undefined,
        context: {
          isCarMarket: true,
          data: car ?? {},
          currencies: this.currencies,
          isLoadingCalc: this.isLoading,
          vehicleValue: this.vehicleValue,
          importType: this.importType,
          coll: true
        }
      };

      // this.calculate(car);
      // check vin
      // this.carsService.vinCheck({vin: car.vin, listingId: car.listingId}).subscribe((res: any) => {
      //   if (res.res === 'found') {
      // const self = this;
      // const loadingSubscription = this.isLoading.subscribe(isLoading => {
      //   // if (!isLoading) {
      //   //   this.vehicleValue.next(self.calculate(car) || {});
      //   // }
      // });
      this.carModalDialogLoaded = true;
      const dialogRef = this.dialogService.open(CarModalComponent, dialogConfig);

      if (isMobile) {
        dialogRef.componentRef.instance.nbDialogRef = dialogRef; // Set the dialogRef in the component
      }

      this.carsService.updateInterest(car.id, 'RequestedMoreInfo', this.importType).subscribe((res: any) => {
        console.log('cc', res);
      });

      dialogRef.onClose.subscribe((result: any) => {
        try {
          this.carModalDialogLoaded = false;
          // setTimeout(() => {
          this.router.navigate([], {
            queryParams: {
              id: null,
              importType: this.importType,
              tab: 1
            },
            queryParamsHandling: 'merge'
          });
          // });

          // Action to be performed when the dialog closes
          const dialogResult = result ?? dialogConfig.context.data;
          console.log('Dialog closed', dialogResult);

          dataLayer.push({
            event: 'cars-grid-dialog-closed_pub',
            item_id: dialogResult.id,
            item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
            item_price: dialogResult.CarPrice,
            item_year: dialogResult.ManufactureDate,
          });


        } catch (err: any) {
          console.error(err);
        }
      });
      // }
      //   else {
      //     alert('הרכב נמכר ולא נמצא במאגר');
      //   }
      // });
    }

    getExwByExwId(data: any, id) {
      for (const option of data.options) {
        for (const exw of option.exw) {
          if (exw.id === id) {
            return exw;
          }
        }
      }

      return null;
    }

    getHarborByExwId(data, id) {
      return data.options.find(option =>
        option.exw.some(exw => exw.id === id)
      );
    }

    getDisHarborByExwId = (data, id) => {
      for (const option of data.options) {
        for (const exw of option.exw) {
          if (exw.id === id) {
            return exw.dHarbor;
          }
        }
      }

      return null;
    };

    onYearChange(year: string) {
      this.selectedYear = year;
      // this.selectedMake = 'הכל';
      // this.selectedModel = 'הכל';
      // this.selectedFuelType = 'הכל';
    }

    onMakeChange(make: string) {
      this.selectedMake = make;

      this.models = Array.from(new Set(
        ['הכל'].concat(
          this.filterMetaCars
            .filter((car) => car.make_h === make)
            .map((car) => car.model.map((model: any) => model.name))
            .reduce((acc, val) => acc.concat(val), [])
        )
      ));

      this.selectedModel = 'הכל';


    }

    onModelChange(model: string) {
      this.selectedModel = model;
    }

    onFuelChange(fuel: string) {
      this.selectedFuelType = fuel;
    }

    toggleFilter() {
      this.isFilterCollapsed = !this.isFilterCollapsed;
    }

    // type = normal | interested | liked
    filter(type: string = 'normal') {
      this.loading = true;
      // Show overlay
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'loading-backdrop',
        positionStrategy: this.overlay
          .position()
          .flexibleConnectedTo(this.carContainer)
          .withPositions([{
            originX: 'center',
            originY: 'center',
            overlayX: 'center',
            overlayY: 'center'
          }])
      });


      const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);

      // const loadingPortal = new ComponentPortal(this.loadingOverlay);
      this.overlayRef.attach(loadingPortal);

      if (type === 'normal') {
        const year = this.selectedYear === 'הכל' ? -1 : parseInt(this.selectedYear, 0);
        const make = this.selectedMake === 'הכל' ? '' : this.filterMetaMakes.find((m: any) => m.make_h === this.selectedMake)?.make ?? '';

        // TODO: fix this
        const model = this.selectedModel === 'הכל' ? '' : this.selectedModel;

        // TODO: fix this
        let fueltype = '';
        switch (this.selectedFuelType) {
          case 'הכל':
            fueltype = '';
            break;
          case 'דיזל':
            fueltype = 'diesel';
            break;
          case 'בנזין':
            fueltype = 'petrol';
            break;
          case 'היברידי':
            fueltype = 'hybrid';
            break;
          case 'חשמלי':
            fueltype = 'electric';
            break;
          case 'פלאג אין':
            fueltype = 'plug-in';
            break;

        }
        // const fueltype = this.selectedFuelType === 'הכל'
        //     ? ''
        //     : this.filterMetaModels.find((m: any) => m?.fuelType_h === this.selectedFuelType)?.fuelType ?? '';

        this.year = year,
          this.make = make,
          this.model = model,
          this.fueltype = fueltype,
          this.priceRange = `${this.sliderValue}-${this.sliderHighValue}`,
          this.kmRange = `${this.sliderKmValue}-${this.sliderKmHighValue}`,


          this.carsService.filterPagedColl({
            page: 1,
            yearMin: this.sliderYearValue,
            yearMax: this.sliderHighYearValue,
            make: this.make,
            model: this.model,
            fueltype: this.fueltype,
            priceRange: `${this.sliderValue}-${this.sliderHighValue}`,
            kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
            locatedInIsrael: this.locatedInIsrael,
            saleCondition: this.saleCondition,
            importType: this.importType
          })
            .subscribe ((cars: any) => {
              this.cars = cars.map((car) => ({
                ...car,
                isLiked: car.interest === 'Liked'
              }));
              this.fetchedCars = this.cars;
              this.filterByRange();
              this.loading = false;
              this.toggleFilter();
              this.overlayRef.detach();
              console.log('reset scroll call');
              this.resetScroll();
              this.hasMore = cars.length !== 0;
            });
      } else if (type === 'interested') {
        this.carsService.filterInterested({})
          .subscribe((cars: any) => {
            this.cars = cars.map((car) => ({
              ...car,
              isLiked: car.interest === 'Liked' || car.interest === 'RequestedMoreInfo'
            }));
            this.fetchedCars = this.cars;
            this.filterByRange();
            this.loading = false;
            this.toggleFilter();
            this.overlayRef.detach();
            this.resetScroll();
          });

      } else if (type === 'liked') {
        this.carsService.filterLiked({})
          .subscribe((cars: any) => {
            this.cars = cars.map((car) => ({
              ...car,
              isLiked: true, //car.interest === 'Liked'
            }));
            this.fetchedCars = this.cars;
            this.filterByRange();
            this.loading = false;
            this.toggleFilter();
            this.overlayRef.detach();
            this.resetScroll();
          });
      }
    }

    // isMobileView() {
    //   // Return true if the screen width is less than or equal to 768px, otherwise false
    //   return window.innerWidth <= 768;
    // }
    @Input() selected!: boolean;


    onSliderChangeEnd($event: ChangeContext) {
      console.log($event);
      // this.sliderValue = $event.value;
      // this.sliderHighValue = $event.highValue;
      this.filterByRange();
      console.log(this.cars.length);
    }

    onSliderYearChangeEnd($event: ChangeContext) {
      console.log($event);
      // this.sliderValue = $event.value;
      // this.sliderHighValue = $event.highValue;
      this.filterByRange();
      console.log(this.cars.length);
    }

    onSliderKmChangeEnd($event: ChangeContext) {
      console.log($event);
      // this.sliderValue = $event.value;
      // this.sliderHighValue = $event.highValue;
      this.filterByRange();
      console.log(this.cars.length);
    }

    filterByRange() {
      this.cars = this.fetchedCars;
      console.log(this.cars);
      this.cars = this.cars.filter((car) => {
        return (car.C_Price_Collector >= this.sliderValue && car.C_Price_Collector <= this.sliderHighValue) &&
          (car.Year >= this.sliderYearValue && car.Year <= this.sliderHighYearValue) &&
          (car.Mileage >= this.sliderKmValue && car.Mileage <= this.sliderKmHighValue) &&
          ((car.Location === 'Israel' && this.locatedInIsrael === 'Yes')
            || (car.Location !== 'Israel' && this.locatedInIsrael === 'No')
            || this.locatedInIsrael === 'All') &&
          ((car.SaleCondition === 'New' && this.saleCondition === 'New')
            || (car.SaleCondition !== 'New' && this.saleCondition === 'Used')
            || this.saleCondition === 'All');
        // && ((car.importType === 'Commercial' && this.saleCondition === 'Commercial')
      });
    }

    onLocationToggleChange($event: any): void {
      this.filterByRange();
    }

    onCarSaleConditionToggleChange($event: any): void {
      this.filterByRange();
    }

    onCarImportTypeToggleChange($event: any): void {
      this.router.navigate([], {
        queryParams: {
          id: null,
          importType: this.importType,
          tab: 1
        },
        queryParamsHandling: 'merge'
      });
      this.filterByRange();
    }


    getFuelTypeHebrew(type: any) {
      if (this.showDirham) { return type; }

      switch (type) {
        case '':
          return '';
        case 'diesel':
          return 'דיזל';
        case 'petrol':
          return 'בנזין';
        case 'hybrid':
          return 'היברידי';
        case 'electric':
          return 'חשמלי';
        case 'plug-in':
          return 'פלאג אין';

      }
    }

    cancelCar(car: any) {
      this.carsService.setAdminStatus(car.id, 'Cancelled').subscribe((res: any) => {
        // this.snackBar.open('המוצר נבדק', 'סגור', {
        //     duration: 2000,
        // });
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: {
            id: null,
            importType: this.importType,
            tab: 1
          },
          queryParamsHandling: 'merge'
        });
      });
    }

    // isAdmin() {
    //   return this.user.role.includes('admin');
    // }
  }



